
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as catalogLWWEIG0_45f7N2q2COWPs96jHzhShznO5jhI3mJ2jQoTsMeta } from "/app/pages/catalog.vue?macro=true";
import { default as sign_45upLl0xMIKSZUopI7CFFcJlXi_454XTAwEx0pwpc6UBNsV6EMeta } from "/app/pages/sign-up.vue?macro=true";
import { default as alignersC8Yon4NLIHbyuKPe7AgrbJtx3GTIqygeqLb0EhCn3owMeta } from "/app/pages/aligners.vue?macro=true";
import { default as indexgXAvaMPwKrurPyfrnchlOoI4Og1SV7Q_45uxSxTgQKpqEMeta } from "/app/pages/cart/index.vue?macro=true";
import { default as diagnosticsBrJ8U_dO2a71mAUgq8_45WJqA5G7K9UeeIEwHif_45_EjW4Meta } from "/app/pages/diagnostics.vue?macro=true";
import { default as instructionsLfEeAfkhJrr_45DqnNm_45eI4RSlHtksJuUVIfa_45Srw_458bUMeta } from "/app/pages/instructions.vue?macro=true";
import { default as indexKGFpJrfaPGuuhppiHh6jzgX1cc0MaKSlIxKJ_45q3hxrYMeta } from "/app/pages/account/index.vue?macro=true";
import { default as confirm_45emailmOQPuQsguw3wpmY58YmTJo9FKxdfbof0kTYkEAlEayEMeta } from "/app/pages/confirm-email.vue?macro=true";
import { default as privacy_45policyzgG_45S68_451GHrVnCshLKLsmg43yjC4fB7Q3UU1pkWXTMMeta } from "/app/pages/privacy-policy.vue?macro=true";
import { default as customizer7BBBcQ9fD_456e1pkKdEl8KsNwqLbzyoe6nQL2ynJcuOQMeta } from "/app/pages/cart/customizer.vue?macro=true";
import { default as forgot_45passwordgdzNcmliYSc_RqJLDFi4QKABybrSV1OTdLl0SK_45V07UMeta } from "/app/pages/forgot-password.vue?macro=true";
import { default as surgical_45guidesV_45pXOJmaZpkB_j5tQrPIfxf6XP0LvHPdeEonrcZcsmEMeta } from "/app/pages/surgical-guides.vue?macro=true";
import { default as referralJarUs6S2jx89OC3WOti_45HRbSVhdCVB3SPctqnuRCy7oMeta } from "/app/pages/account/referral.vue?macro=true";
import { default as check_45your_45emaillN_45MY0bLwpegBgNDH5Wn5sJc5dkdRLy6TWjdSCY3LqMMeta } from "/app/pages/check-your-email.vue?macro=true";
import { default as explore_45benefitsmjTdwRr_45ef5AOaEqUF73d_45N6Mklan5BOLVav_9UZ7BwMeta } from "/app/pages/explore-benefits.vue?macro=true";
import { default as fixed_45appliancesGEEbBWw0WRfiKlILwLEMgcy9bH9vy5pmB7oYhwp7u_45IMeta } from "/app/pages/fixed-appliances.vue?macro=true";
import { default as terms_45conditionszuLNpQmRCZaAKKRTh424JrqP0JiuwjDSq8bLR7U_wOcMeta } from "/app/pages/terms-conditions.vue?macro=true";
import { default as signature_45applianceswFXQQv5SM9YyFLzTnj73ukWvXewYcZmHwYPZz7aeDVkMeta } from "/app/pages/signature-appliances.vue?macro=true";
import { default as index2MrUm7B2VD1EI5nmGyNzYVgHgXfo5_45jA6U7Q4XBhTzMMeta } from "/app/pages/account/history/index.vue?macro=true";
import { default as functional_45appliancesyc8VDEHs7_QC8EuHxgVrYDounS1St8fSMIuVXluHZDgMeta } from "/app/pages/functional-appliances.vue?macro=true";
import { default as indexO5DsSsHCHuHWWqtjyO3pLfb0K47gTitmzROCvm_ZT8oMeta } from "/app/pages/panel/dashboard/index.vue?macro=true";
import { default as customizer_45h4V0KpLHagb8t90y09K_ruD_Plt5tUq_45TFJP0PEJ38Meta } from "/app/pages/product/[type]/[item]/customizer.vue?macro=true";
import { default as _91item_93EYu27VdbHvJQtB_45JPiJPIASADnHaWkxp_45kohDBL_XYsMeta } from "/app/pages/product/[type]/[item].vue?macro=true";
import { default as temporary_45prostheticsWie1ij_45_8rZcPH3VVkd8Q24qN_45JjgmUEVzSfiU99BR4Meta } from "/app/pages/temporary-prosthetics.vue?macro=true";
import { default as indexyhgwNwR2aDFcsPMIoSumXZ5gB6NN_fc6LeXCj_enkzAMeta } from "/app/pages/account/delivery/index.vue?macro=true";
import { default as indexLhrAuhbpnN9a0AW4f8l1u_45NoDYycfmjtQbTwdXc63kYMeta } from "/app/pages/panel/order-list/index.vue?macro=true";
import { default as _91token_93QH8pQwDzqrJaWhQilLRVdsy3O_45uKLFi4VGIk9_ziXd0Meta } from "/app/pages/reset-password/[token].vue?macro=true";
import { default as indextcU_45Wt4GpFSOK464ldFR0xNWw5U7fOnPvnPOpG0isQwMeta } from "/app/pages/account/dashboard/index.vue?macro=true";
import { default as _91order_93huan6xkImfg7XUvZoBhi2Xdh23PgPqtAP7lMChnOIFYMeta } from "/app/pages/account/history/[order].vue?macro=true";
import { default as _91order_93UZFb8Y_45S_DkOfu2suCwyF_45xam6x7WarRf4YkKEFL238Meta } from "/app/pages/panel/dashboard/[order].vue?macro=true";
import { default as biomechanical_45appliancesWGKfnSEYXgwus2cyNr4EZGEImGxZxjofcJyyJes44_45cMeta } from "/app/pages/biomechanical-appliances.vue?macro=true";
import { default as _91order_93JpBquqScH342SY_FVljjgTn2iFaMTNOYu1EJFjIfQQgMeta } from "/app/pages/panel/order-list/[order].vue?macro=true";
import { default as _91order_93XPonzOQShSlJICVwI_Mt2xkL5nWhJ91c_45_GLn4wOObMMeta } from "/app/pages/account/dashboard/[order].vue?macro=true";
import { default as custom_45aligner_45facilitators0k8wBJsMjDZtmRTEUrMF_2amTHF279Z9sXF_xExy6tIMeta } from "/app/pages/custom-aligner-facilitators.vue?macro=true";
import { default as custom_45biomechanical_45applianceszDN1AukV_45G9hLNXz6zCj_451Y7pd1DJ6ozF_mfAX107_45YMeta } from "/app/pages/custom-biomechanical-appliances.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("/app/pages/catalog.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/app/pages/sign-up.vue")
  },
  {
    name: "aligners",
    path: "/aligners",
    component: () => import("/app/pages/aligners.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("/app/pages/cart/index.vue")
  },
  {
    name: "diagnostics",
    path: "/diagnostics",
    component: () => import("/app/pages/diagnostics.vue")
  },
  {
    name: "instructions",
    path: "/instructions",
    component: () => import("/app/pages/instructions.vue")
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("/app/pages/confirm-email.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/app/pages/privacy-policy.vue")
  },
  {
    name: "cart-customizer",
    path: "/cart/customizer",
    component: () => import("/app/pages/cart/customizer.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/app/pages/forgot-password.vue")
  },
  {
    name: "surgical-guides",
    path: "/surgical-guides",
    component: () => import("/app/pages/surgical-guides.vue")
  },
  {
    name: "account-referral",
    path: "/account/referral",
    meta: referralJarUs6S2jx89OC3WOti_45HRbSVhdCVB3SPctqnuRCy7oMeta || {},
    component: () => import("/app/pages/account/referral.vue")
  },
  {
    name: "check-your-email",
    path: "/check-your-email",
    component: () => import("/app/pages/check-your-email.vue")
  },
  {
    name: "explore-benefits",
    path: "/explore-benefits",
    component: () => import("/app/pages/explore-benefits.vue")
  },
  {
    name: "fixed-appliances",
    path: "/fixed-appliances",
    component: () => import("/app/pages/fixed-appliances.vue")
  },
  {
    name: "terms-conditions",
    path: "/terms-conditions",
    component: () => import("/app/pages/terms-conditions.vue")
  },
  {
    name: "signature-appliances",
    path: "/signature-appliances",
    component: () => import("/app/pages/signature-appliances.vue")
  },
  {
    name: "account-history",
    path: "/account/history",
    component: () => import("/app/pages/account/history/index.vue")
  },
  {
    name: "functional-appliances",
    path: "/functional-appliances",
    component: () => import("/app/pages/functional-appliances.vue")
  },
  {
    name: "panel-dashboard",
    path: "/panel/dashboard",
    component: () => import("/app/pages/panel/dashboard/index.vue")
  },
  {
    name: "product-type-item",
    path: "/product/:type()/:item()",
    component: () => import("/app/pages/product/[type]/[item].vue"),
    children: [
  {
    name: "product-type-item-customizer",
    path: "customizer",
    component: () => import("/app/pages/product/[type]/[item]/customizer.vue")
  }
]
  },
  {
    name: "temporary-prosthetics",
    path: "/temporary-prosthetics",
    component: () => import("/app/pages/temporary-prosthetics.vue")
  },
  {
    name: "account-delivery",
    path: "/account/delivery",
    component: () => import("/app/pages/account/delivery/index.vue")
  },
  {
    name: "panel-order-list",
    path: "/panel/order-list",
    component: () => import("/app/pages/panel/order-list/index.vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    component: () => import("/app/pages/reset-password/[token].vue")
  },
  {
    name: "account-dashboard",
    path: "/account/dashboard",
    component: () => import("/app/pages/account/dashboard/index.vue")
  },
  {
    name: "account-history-order",
    path: "/account/history/:order()",
    component: () => import("/app/pages/account/history/[order].vue")
  },
  {
    name: "panel-dashboard-order",
    path: "/panel/dashboard/:order()",
    component: () => import("/app/pages/panel/dashboard/[order].vue")
  },
  {
    name: "biomechanical-appliances",
    path: "/biomechanical-appliances",
    component: () => import("/app/pages/biomechanical-appliances.vue")
  },
  {
    name: "panel-order-list-order",
    path: "/panel/order-list/:order()",
    component: () => import("/app/pages/panel/order-list/[order].vue")
  },
  {
    name: "account-dashboard-order",
    path: "/account/dashboard/:order()",
    component: () => import("/app/pages/account/dashboard/[order].vue")
  },
  {
    name: "custom-aligner-facilitators",
    path: "/custom-aligner-facilitators",
    component: () => import("/app/pages/custom-aligner-facilitators.vue")
  },
  {
    name: "custom-biomechanical-appliances",
    path: "/custom-biomechanical-appliances",
    component: () => import("/app/pages/custom-biomechanical-appliances.vue")
  }
]